import { Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

/**
 * Empty state of the channel list. The SDK evaluates emptiness AFTER channelRenderFilterFn, so
 * this covers client-side filtered categories (Mutual/Shopping) as well as genuinely empty ones.
 * Deliberately category-agnostic: every tab's empty answer is the same "nothing here yet".
 */
export const ChatChannelListEmpty = () => {
  const { t } = useResource();

  return (
    <Stack alignItems="center" justifyContent="center" height="100%" p={3}>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {t(Resources.Chat.NoChannels)}
      </Typography>
    </Stack>
  );
};
